@if (columnDetails?.render === 'input-box') {
    <div class="input-box">
        <lokos-input
            [placeholder]="columnDetails?.placeholder"
            [required]="false"
            [type]="columnDetails?.type"
            [value]="rowData[columnDetails?.field]"
            (afterInput)="onInput($event)"
            (afterIconClick)="onIconClick()"
            [isIcon]="columnDetails?.isIcon"
            [iconPosition]="columnDetails?.iconPosition"
            [readonly]="columnDetails?.readonly"
            [iconPath]="columnDetails?.iconPath"
        />
    </div>
}
@if (columnDetails?.render === 'input-box-paid') {
    <div class="input-box-paid">
        <lokos-input
            [placeholder]="columnDetails?.placeholder"
            [required]="false"
            [type]="columnDetails?.type"
            [value]="rowData[columnDetails?.field]"
            (afterInput)="onInput($event)"
            (afterIconClick)="onIconClick()"
            [isIcon]="columnDetails?.isIcon"
            [iconPosition]="columnDetails?.iconPosition"
            [readonly]="columnDetails?.readonly"
            [iconPath]="columnDetails?.iconPath"
            [isAmount]="true"
        />
        <p class="loan-interest-hint">
            {{ 'loan' | translate }} + {{ 'interest' | translate }} :
            {{ rowData['maxOs'] | indianCurrency: true }}
        </p>
    </div>
}

@if (columnDetails?.render === 'file-input') {
    <div class="file-input">
        <lokos-file
            [acceptFormat]="columnDetails?.acceptFormat"
            [required]="true"
            (onChangeFile)="onFileSelected($event)"
        />
    </div>
}
@if (columnDetails?.render === 'date-picker') {
    <div class="date-picker">
        <lokos-date-picker
            [placeholder]="columnDetails?.placeholder"
            [required]="true"
            (afterDateChange)="onDateChange($event)"
            [value]="rowData[columnDetails?.field]"
        />
    </div>
}

@if (columnDetails?.render === 'select-date') {
    <div class="date-picker">
        <lokos-date-picker
            [placeholder]="'selectDate'"
            [required]="false"
            (afterDateChange)="afterDateChange($event)"
            [value]="rowData[columnDetails?.field]"
        />
    </div>
}

@if (columnDetails?.format === 'date') {
    <div matTooltip="{{ rowData[columnDetails?.field] | date: 'dd-MM-yyyy' }}">
        {{ rowData[columnDetails?.field] | date: 'dd-MM-yyyy' }}
    </div>
}

@if (columnDetails?.render === 'select-box') {
    <div class="select-box">
        <lokos-select
            (afterSelectionChange)="afterSelectionChange($event)"
            [placeholder]="columnDetails?.placeholder"
            [optionsList]="columnDetails?.optionsList"
            [required]="false"
            [value]="rowData[columnDetails?.field]"
            [displayName]="columnDetails?.displayName"
            [getName]="columnDetails?.getName"
            [multiSelect]="columnDetails?.multiSelect"
        />
    </div>
}

@if (
    columnDetails?.render === 'rejection-box' && rowData.isShowRejectionDropdown
) {
    <div class="select-box">
        <lokos-select
            (afterSelectionChange)="afterSelectionChange($event)"
            [placeholder]="columnDetails?.placeholder"
            [optionsList]="rowData?.optionList"
            [required]="false"
            [value]="rowData[columnDetails?.field]"
            [displayName]="columnDetails?.displayName"
            [getName]="columnDetails?.getName"
            [multiSelect]="columnDetails?.multiSelect"
        />
    </div>
}

@if (columnDetails?.render === 'base-button') {
    <div class="button-box">
        <lokos-button
            [label]="columnDetails?.disLabel"
            [type]="columnDetails?.type"
            [disabled]="columnDetails?.disabled"
            (afterClick)="onButtonClick()"
        />
    </div>
}

@if (columnDetails?.render === 'fab-button') {
    <div class="button-box">
        <lokos-fab-button
            [type]="columnDetails?.type"
            [iconPath]="columnDetails?.iconPath"
            [disabled]="columnDetails?.disabled"
            (afterClick)="onButtonClick()"
        />
    </div>
}

@if (columnDetails?.render === 'button' && columnDetails?.type === 'delete') {
    <lokos-button
        [type]="'icon'"
        [isIcon]="true"
        [iconPath]="'assets/images/trash.svg'"
        (afterClick)="onButtonClick()"
        [changeIconTheme]="true"
        [iconWidth]="'1.5rem'"
        [iconHeight]="'1.5rem'"
    />
}

@if (columnDetails?.render === 'link') {
    <a class="link-button" (click)="onButtonClick()">
        {{ rowData[columnDetails?.field] || 'Click' }}
    </a>
}
@if (columnDetails?.render === 'report-link') {
    @if (columnDetails?.field === 'promoterName') {
        @if (rowData.promoterId === 2 || rowData.promoterId === 3) {
            <a class="link-button" (click)="onReportLinkClick()">
                <u>{{ rowData[columnDetails?.field] }}</u>
            </a>
        } @else {
            {{ rowData[columnDetails?.field] }}
        }
    } @else {
        <a class="link-button" (click)="onReportLinkClick()">
            <u>{{ rowData[columnDetails?.field] }}</u>
        </a>
    }
}
@if (columnDetails?.render === 'download-link') {
    <button (click)="onReportLinkClick()" [matTooltip]="'Download'">
        <img src="/assets/images/download.svg" alt="icon" />
    </button>
}

@if (columnDetails?.render === 'html') {
    <div [innerHTML]="rowData[columnDetails?.field]"></div>
}

@if (columnDetails?.render === 'button' && columnDetails?.type === 'view') {
    @if (columnDetails?.field === 'transaction') {
        <lokos-button
            [type]="'icon'"
            [isIcon]="true"
            [iconPath]="'assets/images/eye.svg'"
            (afterClick)="handleTransactionClick(rowData.transactionFlag)"
            [changeIconTheme]="true"
            [iconWidth]="'1.5rem'"
            [iconHeight]="'1.5rem'"
            [disabled]="rowData.transactionFlag"
        />
    } @else if (columnDetails?.field === 'loan_fund_status') {
        <lokos-button
            [type]="'icon'"
            [isIcon]="true"
            [iconPath]="'assets/images/eye.svg'"
            (afterClick)="!rowData.loanFundFlag && onButtonClick()"
            [changeIconTheme]="true"
            [iconWidth]="'1.5rem'"
            [iconHeight]="'1.5rem'"
            [disabled]="rowData.loanFundFlag"
        />
    } @else {
        <lokos-button
            [type]="'icon'"
            [isIcon]="true"
            [iconPath]="'assets/images/detail.svg'"
            (afterClick)="onButtonClick()"
            [changeIconTheme]="true"
            [iconWidth]="'1.5rem'"
            [iconHeight]="'1.5rem'"
        />
    }
}

@if (columnDetails?.render === 'verify-button') {
    <lokos-button
        [type]="'icon'"
        [isIcon]="true"
        [iconPath]="'assets/images/verify.svg'"
        (afterClick)="onButtonClick()"
        [iconWidth]="'1.5rem'"
        [iconHeight]="'1.5rem'"
    />
}
@if (columnDetails?.render === 'verified-icon') {
    <div class="verified-icon">
        @if (rowData[columnDetails?.field]) {
            <img src="assets/images/verfied.svg" alt="verified" />
            {{ 'verified' | translate }}
        } @else {
            -
        }
    </div>
}

@if (entity === 'user_profile') {
    @if (columnDetails?.field === 'status') {
        <div
            class="profile-status"
            [ngClass]="{
                inactive: rowData[columnDetails?.field] === 'Inactive',
                approved: rowData[columnDetails?.field] === 'Approved',
                pending: rowData[columnDetails?.field] === 'Pending',
                rejected: rowData[columnDetails?.field] === 'Rejected',
            }"
        >
            <div class="dot"></div>
            <p>{{ rowData[columnDetails?.field] }}</p>
        </div>
    }
    @if (columnDetails?.field === 'first_name') {
        <p>
            {{ (rowData.first_name || '') + ' ' + (rowData.last_name || '') }}
        </p>
    }
    @if (columnDetails.field === 'application') {
        <p>{{ rowData.application.description | titlecase }}</p>
    }
    @if (columnDetails.field === 'role') {
        <p>{{ rowData.role.description | titlecase }}</p>
    }
    @if (columnDetails.field === '_created') {
        <p>{{ rowData._created * 1000 | date: 'dd MMM yyyy hh:mm:ss a' }}</p>
    }
    @if (columnDetails.field === 'location') {
        <p [innerHTML]="getLocation()"></p>
    }
}

@if (
    entity === 'linked_shg_list' ||
    entity === 'linked_vo_list' ||
    entity === 'aajeevika_member_list' ||
    entity === 'shg-regular-loan-repayment-table' ||
    entity === 'shg-regular-loan-disbursement-table' ||
    entity === 'shg-regular-loan-request-table'
) {
    @if (
        columnDetails?.field === 'shg_name' ||
        columnDetails?.field === 'federation_name' ||
        columnDetails?.field === 'memberName' ||
        columnDetails?.field === 'memberNameCode'
    ) {
        <div class="link" (click)="onLinkClick(rowData[columnDetails?.field])">
            {{ rowData[columnDetails?.field] }}
        </div>
    }

    @if (columnDetails?.field === 'view_status') {
        @if (rowData['status'] === 2) {
            <div class="profile-status" [ngClass]="{ inactive: true }">
                <p>{{ 'inactive' | translate }}</p>
            </div>
        } @else {
            <div
                class="profile-status"
                [ngClass]="{
                    'approved-bpm':
                        rowData[columnDetails?.field] === 'Approved by BPM',
                    'rejected-bpm':
                        rowData[columnDetails?.field] === 'Rejected by BPM',
                    new: rowData[columnDetails?.field] === 'New',
                    'not-mapped':
                        rowData[columnDetails?.field] === 'Not Mapped',
                    'pending-bookkeeper':
                        rowData[columnDetails?.field] ===
                        'Pending with Bookkeeper',
                    'modified-autosync':
                        rowData[columnDetails?.field] === 'Modified (Autosync)',
                    modified: rowData[columnDetails?.field] === 'Modified',
                    'new-rejected':
                        rowData[columnDetails?.field] === 'New(Rejected)',
                    inactive: rowData[columnDetails?.field] === 'Inactive',
                }"
            >
                <p>{{ rowData[columnDetails?.field] }}</p>
            </div>
        }
    }
}

@if (entity === 'shg_profile_component') {
    @if (
        columnDetails?.field === 'shg_name' ||
        columnDetails?.field === 'member_count' ||
        columnDetails?.field === 'shg_members_list' ||
        columnDetails?.field === 'member_count_tobe_approve'
    ) {
        @if (rowData[columnDetails?.field] === 'view') {
            <lokos-button
                [type]="'icon'"
                [isIcon]="true"
                [iconPath]="'assets/images/eye.svg'"
                (afterClick)="onLinkClick(rowData[columnDetails?.field])"
                [changeIconTheme]="true"
                [iconWidth]="'1.5rem'"
                [iconHeight]="'1.5rem'"
            />
        } @else if (rowData[columnDetails?.field]) {
            <div
                class="link"
                (click)="onLinkClick(rowData[columnDetails?.field])"
            >
                {{ rowData[columnDetails?.field] }}
            </div>
        } @else {
            <div>
                {{ rowData[columnDetails?.field] }}
            </div>
        }
    }

    @if (columnDetails?.field === 'view_status') {
        @if (rowData['status'] === 2) {
            <div class="profile-status" [ngClass]="{ inactive: true }">
                <p>{{ 'inactive' | translate }}</p>
            </div>
        } @else {
            <div
                class="profile-status"
                [ngClass]="{
                    'approved-bpm':
                        rowData[columnDetails?.field] === 'Approved by BPM',
                    'rejected-bpm':
                        rowData[columnDetails?.field] === 'Rejected by BPM',
                    new: rowData[columnDetails?.field] === 'New',
                    'not-mapped':
                        rowData[columnDetails?.field] === 'Not Mapped',
                    'pending-bookkeeper':
                        rowData[columnDetails?.field] ===
                        'Pending with Bookkeeper',
                    'modified-autosync':
                        rowData[columnDetails?.field] === 'Modified (Autosync)',
                    modified: rowData[columnDetails?.field] === 'Modified',
                    'new-rejected':
                        rowData[columnDetails?.field] === 'New(Rejected)',
                    inactive: rowData[columnDetails?.field] === 'Inactive',
                }"
            >
                <p>{{ rowData[columnDetails?.field] }}</p>
            </div>
        }
    }
}

@if (
    entity === 'potential_didi_list_component' ||
    entity === 'potential_didi_approve_component'
) {
    @if (columnDetails?.field === 'approval_status') {
        <div
            class="profile-status"
            [ngClass]="{
                approved: rowData[columnDetails?.field] === 'Approved',
                pending: rowData[columnDetails?.field] === 'Pending',
                rejected: rowData[columnDetails?.field] === 'Rejected',
                submitted: rowData[columnDetails?.field] === 'Submitted',
            }"
        >
            <p>{{ rowData[columnDetails?.field] }}</p>
        </div>
    }
}

@if (entity === 'potential_didi_verification_component') {
    @if (columnDetails?.field === 'approvalStatus') {
        <div
            class="profile-status"
            [ngClass]="{
                approved: rowData[columnDetails?.field] === 'Approved',
                pending: rowData[columnDetails?.field] === 'Pending',
                rejected: rowData[columnDetails?.field] === 'Rejected',
                submitted: rowData[columnDetails?.field] === 'Submitted',
                declared: rowData[columnDetails?.field] === 'Declared',
                reconsideration:
                    rowData[columnDetails?.field] === 'Reconsideration',
            }"
        >
            <p>{{ rowData[columnDetails?.field] }}</p>
        </div>
    }
}

@if (entity === 'clf_profile_component') {
    @if (columnDetails?.field === 'view_status') {
        @if (rowData['status'] === 2) {
            <div class="profile-status" [ngClass]="{ inactive: true }">
                <p>{{ 'inactive' | translate }}</p>
            </div>
        } @else {
            <div
                class="profile-status"
                [ngClass]="{
                    'approved-bpm':
                        rowData[columnDetails?.field] === 'Approved by BPM',
                    'pending-bookkeeper':
                        rowData[columnDetails?.field] ===
                        'Pending with Bookkeeper',
                    new: rowData[columnDetails?.field] === 'New',
                    modified: rowData[columnDetails?.field] === 'Modified',
                    'rejected-bpm':
                        rowData[columnDetails?.field] === 'Rejected by BPM',
                    inactive: rowData[columnDetails?.field] === 'Inactive',
                    'approved-nic':
                        rowData[columnDetails?.field] === 'Approved by NIC',
                    'rejected-nic':
                        rowData[columnDetails?.field] === 'Rejected by NIC',
                }"
            >
                <p>{{ rowData[columnDetails?.field] }}</p>
            </div>
        }
    }

    @if (
        columnDetails?.field === 'clfName' ||
        columnDetails?.field === 'cbo_mapping_count'
    ) {
        <div class="link" (click)="onLinkClick(rowData[columnDetails?.field])">
            {{ rowData[columnDetails?.field] }}
        </div>
    }
}

@if (entity === 'clf-meeting-component') {
    @if (columnDetails?.field === 'approvalStatus') {
        <div
            class="profile-status"
            [ngClass]="{
                pending: rowData[columnDetails?.field] === 'Pending',
                rejected: rowData[columnDetails?.field] === 'Rejected',
                approved: rowData[columnDetails?.field] === 'Approved',
                'under-review':
                    rowData[columnDetails?.field] === 'Under Review',
            }"
        >
            <p>{{ rowData[columnDetails?.field] }}</p>
        </div>
    }

    @if (columnDetails?.field === 'meetingType') {
        <div class="link" (click)="onLinkClick(rowData[columnDetails?.field])">
            {{ rowData[columnDetails?.field] }}
        </div>
    }
}

@if (entity === 'shg-meeting-component') {
    @if (columnDetails?.field === 'shgName') {
        <div class="link" (click)="onLinkClick(rowData[columnDetails?.field])">
            {{ rowData[columnDetails?.field] }}
        </div>
    }
}

@if (entity === 'vo-meeting-component') {
    @if (columnDetails?.field === 'voName') {
        <div class="link" (click)="onLinkClick(rowData[columnDetails?.field])">
            {{ rowData[columnDetails?.field] }}
        </div>
    }
}

@if (entity === 'vo-meeting-vo-active') {
    @if (columnDetails?.field === 'borrowedFrom') {
        <div class="link" (click)="onLinkClick(rowData[columnDetails?.field])">
            {{ rowData[columnDetails?.field] }}
        </div>
    }
}

@if (entity === 'vo-meeting-shg-active') {
    @if (columnDetails?.field === 'shgName') {
        <div class="link" (click)="onLinkClick(rowData[columnDetails?.field])">
            {{ rowData[columnDetails?.field] }}
        </div>
    }
}

@if (entity === 'shg_members_list') {
    @if (columnDetails?.field === 'member_name') {
        <div class="link" (click)="onLinkClick(rowData[columnDetails?.field])">
            {{ rowData[columnDetails?.field] }}
        </div>
    }
    @if (columnDetails?.field === 'view_status') {
        <div
            class="profile-status"
            [ngClass]="{
                new: rowData[columnDetails?.field] === 'New',
                modified: rowData[columnDetails?.field] === 'Modified',
                approved:
                    rowData[columnDetails?.field] === 'Activated' ||
                    rowData[columnDetails?.field].includes('Activated') ||
                    rowData[columnDetails?.field].includes('Approved'),
                rejected:
                    rowData[columnDetails?.field] === 'Rejected' ||
                    rowData[columnDetails?.field].includes('Rejected') ||
                    rowData[columnDetails?.field] === 'New(Rejected)',
                inactive: rowData[columnDetails?.field] === 'Inactive',
            }"
        >
            <p>{{ rowData[columnDetails?.field] }}</p>
        </div>
    }
    @if (columnDetails?.render === 'image-preview') {
        @if (rowData[columnDetails?.field]) {
            <lokos-button
                [type]="'icon'"
                [isIcon]="true"
                [iconPath]="'assets/images/image_btn.svg'"
                (afterClick)="onButtonClick()"
                [iconWidth]="'1.5rem'"
                [iconHeight]="'1.5rem'"
            />
        } @else {
            -
        }
    }
}

@if (entity === 'vo_pending_request' || entity === 'clf_pending_request') {
    @if (columnDetails?.field === 'federation_name') {
        <div class="link" (click)="onLinkClick(rowData[columnDetails?.field])">
            {{ rowData[columnDetails?.field] }}
        </div>
    }
    @if (columnDetails?.field === 'view_status') {
        @if (rowData['status'] === 2) {
            <div class="profile-status" [ngClass]="{ inactive: true }">
                <p>{{ 'inactive' | translate }}</p>
            </div>
        } @else {
            <div
                class="profile-status"
                [ngClass]="{
                    'approved-bpm':
                        rowData[columnDetails?.field] === 'Approved by BPM',
                    'rejected-bpm':
                        rowData[columnDetails?.field] === 'Rejected by BPM',
                    new: rowData[columnDetails?.field] === 'New',
                    'not-mapped':
                        rowData[columnDetails?.field] === 'Not Mapped',
                    'pending-bookkeeper':
                        rowData[columnDetails?.field] ===
                        'Pending with Bookkeeper',
                    'modified-autosync':
                        rowData[columnDetails?.field] === 'Modified (Autosync)',
                    modified: rowData[columnDetails?.field] === 'Modified',
                    'new-rejected':
                        rowData[columnDetails?.field] === 'New(Rejected)',
                    inactive: rowData[columnDetails?.field] === 'Inactive',
                }"
            >
                <p>{{ rowData[columnDetails?.field] }}</p>
            </div>
        }
    }
}

@if (entity === 'vo_profile_component') {
    @if (columnDetails?.field === 'view_status') {
        @if (rowData['status'] === 2) {
            <div class="profile-status" [ngClass]="{ inactive: true }">
                <p>{{ 'inactive' | translate }}</p>
            </div>
        } @else {
            <div
                class="profile-status"
                [ngClass]="{
                    'approved-bpm':
                        rowData[columnDetails?.field] === 'Approved by BPM',
                    'pending-bookkeeper':
                        rowData[columnDetails?.field] ===
                        'Pending with Bookkeeper',
                    new: rowData[columnDetails?.field] === 'New',
                    modified: rowData[columnDetails?.field] === 'Modified',
                    'rejected-bpm':
                        rowData[columnDetails?.field] === 'Rejected by BPM',
                    inactive: rowData[columnDetails?.field] === 'Inactive',
                    'approved-nic':
                        rowData[columnDetails?.field] === 'Approved by NIC',
                    'rejected-nic':
                        rowData[columnDetails?.field] === 'Rejected by NIC',
                }"
            >
                <p>{{ rowData[columnDetails?.field] }}</p>
            </div>
        }
    }

    @if (
        columnDetails?.field === 'vo_name' || columnDetails?.field === 'members'
    ) {
        <div class="link" (click)="onLinkClick(rowData[columnDetails?.field])">
            {{ rowData[columnDetails?.field] }}
        </div>
    }
}
@if (
    (entity === 'vo_profile_component' &&
        columnDetails?.field === 'regCertificate' &&
        rowData['view_status'] === 'Approved by BPM') ||
    (entity === 'clf_profile_component' &&
        columnDetails?.field === 'regCertificate' &&
        rowData['view_status'] === 'Approved by BPM')
) {
    <lokos-button
        [type]="'icon'"
        [isIcon]="true"
        [iconPath]="'assets/images/eye.svg'"
        (afterClick)="onButtonClick()"
        [changeIconTheme]="true"
        [iconWidth]="'1.5rem'"
        [iconHeight]="'1.5rem'"
    />
}
@if (entity === 'clf-transaction-meeting-component') {
    @if (columnDetails?.field === 'clfName') {
        <div class="link" (click)="onLinkClick(rowData[columnDetails?.field])">
            {{ rowData[columnDetails?.field] }}
        </div>
    }

    @if (columnDetails?.field === 'flagOpen') {
        <div
            class="profile-status"
            [ngClass]="{
                modified:
                    rowData[columnDetails?.field] === 'Open' ||
                    rowData[columnDetails?.field] === 'o',
                'approved-nic':
                    rowData[columnDetails?.field] === 'Closed' ||
                    rowData[columnDetails?.field] === 'c',
            }"
        >
            <p>
                {{
                    rowData[columnDetails?.field] === 'c'
                        ? 'Closed'
                        : rowData[columnDetails?.field] === 'o'
                          ? 'Open'
                          : rowData[columnDetails?.field]
                }}
            </p>
        </div>
    }
}

@if (entity === 'clf-list-of-meetings') {
    @if (columnDetails?.field === 'meetApprovalStatus') {
        <div
            class="profile-status"
            [ngClass]="{
                modified:
                    rowData[columnDetails?.field] === 'pending' ||
                    rowData[columnDetails?.field] === 'Pending',
                'approved-nic':
                    rowData[columnDetails?.field] === 'approved' ||
                    rowData[columnDetails?.field] === 'Approved',
                'rejected-nic':
                    rowData[columnDetails?.field] === 'rejected' ||
                    rowData[columnDetails?.field] === 'Rejected',
            }"
        >
            <p>{{ rowData[columnDetails?.field] }}</p>
        </div>
    }

    @if (columnDetails?.field === 'flagOpen') {
        <div
            class="profile-status"
            [ngClass]="{
                modified:
                    rowData[columnDetails?.field] === 'Open' ||
                    rowData[columnDetails?.field] === 'o',
                'approved-nic':
                    rowData[columnDetails?.field] === 'Closed' ||
                    rowData[columnDetails?.field] === 'c',
            }"
        >
            <p>{{ rowData[columnDetails?.field] }}</p>
        </div>
    }

    @if (columnDetails?.field === 'mtgType') {
        <div class="link" (click)="onLinkClick(rowData[columnDetails?.field])">
            {{ rowData[columnDetails?.field] }}
        </div>
    }
}

@if (entity === 'clf-meetings-clf-brs') {
    @if (columnDetails?.field === 'chequeNo') {
        @if (!rowData['status']) {
            <div
                class="link"
                (click)="onLinkClick(rowData[columnDetails?.field])"
            >
                {{ rowData[columnDetails?.field] }}
            </div>
        } @else {
            {{ rowData[columnDetails?.field] }}
        }
    }
}

<ng-container *ngIf="entity === 'shg-meeting-list-comoponent'">
    <ng-container
        *ngIf="
            columnDetails?.field === 'shgName' ||
            columnDetails?.field === 'shgNameCode'
        "
    >
        <ng-container *ngIf="rowData.isMeetingFound">
            <div
                [ngClass]="{ link: rowData.isMeetingFound }"
                (click)="onLinkClick(rowData[columnDetails?.field])"
            >
                {{ rowData[columnDetails?.field] }}
            </div>
        </ng-container>
        <ng-container *ngIf="!rowData.isMeetingFound">
            <div>
                {{ rowData[columnDetails?.field] }}
            </div>
        </ng-container>
    </ng-container>
</ng-container>

<ng-container *ngIf="entity === 'vo-meeting-list-comoponent'">
    <ng-container
        *ngIf="
            columnDetails?.field === 'voName' ||
            columnDetails?.field === 'voNameCode'
        "
    >
        <div
            [ngClass]="{ link: rowData.isMeetingFound }"
            (click)="onLinkClick(rowData[columnDetails?.field])"
        >
            {{ rowData[columnDetails?.field] }}
        </div>
    </ng-container>
</ng-container>

<ng-container *ngIf="entity === 'shg-meeting-attendance-list'">
    <div
        class="attendance"
        [ngClass]="{
            present: rowData[columnDetails?.field] === '1',
            absent: rowData[columnDetails?.field] !== '1',
        }"
    >
        <p>{{ rowData[columnDetails?.field] === '1' ? 'P' : 'A' }}</p>
    </div>
</ng-container>

<ng-container *ngIf="entity === 'vo-meeting-regular-attendance-list'">
    <ng-container
        *ngIf="
            rowData['memberNameCode'] === 'Other';
            else todaysAttendanceTemplate
        "
    >
        <div fxLayout="row">
            @for (i of getFixedArray(3); let idx = $index; track $index) {
                <div
                    class="attendance"
                    [ngClass]="{
                        present: idx < (rowData?.attendanceOther || 0),
                        absent: idx >= (rowData?.attendanceOther || 0),
                    }"
                >
                    <p>
                        {{ idx < (rowData?.attendanceOther || 0) ? 'P' : 'A' }}
                    </p>
                </div>
            }
        </div>
    </ng-container>
    <ng-template #todaysAttendanceTemplate>
        <div
            class="attendance"
            [ngClass]="{
                present: rowData[columnDetails?.field] !== '1',
                absent: rowData[columnDetails?.field] === '1',
            }"
        >
            <p>{{ rowData[columnDetails?.field] === '1' ? 'A' : 'P' }}</p>
        </div>
    </ng-template>
</ng-container>

<ng-container
    *ngIf="
        entity === 'vo-meeting-shg-active-loan-list' ||
        entity === 'vo-meeting-vo-active-loan-list'
    "
>
    <ng-container
        *ngIf="
            columnDetails?.field === 'childCboName' ||
            columnDetails?.field === 'childCboNameCode'
        "
    >
        <div class="link" (click)="onLinkClick(rowData[columnDetails?.field])">
            {{ rowData[columnDetails?.field] }}
        </div>
    </ng-container>
</ng-container>

@if (
    entity === 'vo-regular-receipt-bank-to-vo' ||
    entity === 'vo-regular-receipt-clf-to-vo' ||
    entity === 'vo-regular-receipt-other-to-vo' ||
    entity === 'vo-regular-receipt-shg-to-vo' ||
    entity === 'vo-regular-receipt-srlm-to-vo' ||
    entity === 'vo-regular-payment-vo-to-shg' ||
    entity === 'vo-regular-payment-vo-to-clf' ||
    entity === 'vo-regular-payment-vo-to-bank'
) {
    @if (
        (columnDetails?.field === 'loanNumber' &&
            rowData[columnDetails?.field] !== '-') ||
        columnDetails?.field === 'childCboName' ||
        columnDetails?.field === 'childCboNameCode'
    ) {
        <div class="link" (click)="onLinkClick(rowData[columnDetails?.field])">
            {{ rowData[columnDetails?.field] }}
        </div>
    }
}

@if (entity === 'shg_verification_details') {
    @if (columnDetails?.render === 'shg-duplicate-status') {
        @if (rowData[columnDetails?.field]) {
            <lokos-button
                [type]="'default'"
                [isIcon]="true"
                [iconPath]="'assets/images/no_duplicate.svg'"
                [changeIconTheme]="true"
                [iconWidth]="'1.5rem'"
                [iconHeight]="'1.5rem'"
                [label]="rowData[columnDetails?.field]"
            />
        } @else {
            -
        }
    }
    @if (columnDetails?.render === 'image-preview') {
        @if (rowData[columnDetails?.field]) {
            <lokos-button
                [type]="'icon'"
                [isIcon]="true"
                [iconPath]="'assets/images/image_btn.svg'"
                (afterClick)="onButtonClick()"
                [iconWidth]="'1.5rem'"
                [iconHeight]="'1.5rem'"
            />
        } @else {
            -
        }
    }
    @if (columnDetails?.field === 'isOtpVerified') {
        <div
            class="profile-status"
            [ngClass]="{
                approved: rowData[columnDetails?.field] === 'Verified',
                rejected: rowData[columnDetails?.field] === 'Unverified',
            }"
        >
            <div class="dot"></div>
            <p>{{ rowData[columnDetails?.field] }}</p>
        </div>
    }
}

@if (entity === 'aajeevika_epdt_list') {
    @if (columnDetails?.field === 'submittedAt') {
        {{
            rowData.submittedAt
                ? (rowData.submittedAt | date: 'dd MMM yyyy')
                : '-'
        }}
    }
    @if (columnDetails?.field === 'updatedDate') {
        {{
            rowData.updatedDate
                ? (rowData.updatedDate | date: 'dd MMM yyyy')
                : '-'
        }}
    }
    @if (columnDetails?.field === 'totalAajeevikaIncome') {
        {{ rowData.totalAajeevikaIncome || 0 | number: '1.0-0' }}
    }
    @if (columnDetails?.field === 'totalExpectedIncome') {
        {{ rowData.totalExpectedIncome || 0 | number: '1.0-0' }}
    }
    @if (columnDetails?.field === 'status') {
        <div
            class="profile-status"
            [ngClass]="{
                pending: rowData.status === 1,
                approved: rowData.status === 6,
                rejected: rowData.status === 3,
                reconsideration: rowData.status === 7,
                new: rowData.status === 0,
            }"
        >
            <p>{{ getEpdtStatus(rowData.status) }}</p>
        </div>
    }
}

@if (
    entity === 'shg-regular-loan-rescheduling-table' ||
    entity === 'vo-cut-off-member-loan--details-table' ||
    entity === 'shg-cutoff-member-active-loan-details' ||
    entity === 'shg-regular-member-loan-rescheduling-table' ||
    entity === 'shg-regular-loan-repayment-grp-details-table' ||
    entity === 'vo-regular-receipt-clf-to-vo-reschedule' ||
    entity === 'vo-meeting-shg-active-loan-details-table'
) {
    @if (columnDetails?.field === 'loanNo') {
        <div class="link" (click)="onLinkClick(rowData[columnDetails?.field])">
            {{ rowData[columnDetails?.field] }}
        </div>
    }
}

@if (entity === 'shg-regular-loan-repayment-details-table') {
    @if (columnDetails?.field === 'loanNo') {
        @if (rowData['shgMemLoanUuid']) {
            <div
                class="link"
                (click)="onLinkClick(rowData[columnDetails?.field])"
            >
                {{ rowData[columnDetails?.field] }}
            </div>
        } @else {
            {{ rowData[columnDetails?.field] }}
        }
    }
}

@if (entity === 'shg-regular-loan-disbursement-details-table') {
    @if (columnDetails?.field === 'requestId') {
        @if (rowData['amount']) {
            <div
                class="link"
                [matTooltip]="'viewSchedule' | translate"
                (click)="onLinkClick(rowData[columnDetails?.field])"
            >
                {{ rowData[columnDetails?.field] }}
            </div>
        } @else {
            {{ rowData[columnDetails?.field] }}
        }
    }
}

@if (
    entity === 'shg-cutoff-member-active-loans-table' ||
    entity === 'shg-regular-member-loan-rescheduling-table' ||
    entity === 'vo-regular-payment-vo-to-shg-loan-request'
) {
    @if (columnDetails?.field === 'memberNameCode') {
        <div class="link" (click)="onLinkClick(rowData[columnDetails?.field])">
            {{ rowData[columnDetails?.field] }}
        </div>
    }
}

@if (entity === 'shg-regular-group-loan-repayment-table') {
    @if (columnDetails?.field === 'instituteName') {
        <div class="link" (click)="onLinkClick(rowData[columnDetails?.field])">
            {{ rowData[columnDetails?.field] }}
        </div>
    }
}
@if (
    entity === 'list-of-meeting-lending' ||
    entity === 'loan-fund-status-borrowing'
) {
    @if (columnDetails?.field === 'borrowerName') {
        @if (
            !rowData[columnDetails?.field] && rowData['organizationType'] === 1
        ) {
            -
        } @else if (rowData[columnDetails?.field] !== 'Total Amount Received') {
            <div
                class="link"
                (click)="onLinkClick(rowData[columnDetails?.field])"
            >
                {{ rowData[columnDetails?.field] }}
            </div>
        } @else {
            {{ rowData[columnDetails?.field] }}
        }
    }

    @if (columnDetails?.render === 'info-data') {
        @if (rowData[columnDetails?.field]) {
            <div
                class="icon-btn"
                [matTooltip]="rowData?.[columnDetails?.field] || 'View details'"
                matTooltipPosition="above"
                matTooltipShowDelay="300"
            >
                <mat-icon>info</mat-icon>
            </div>
        }
    }
}
@if (entity === 'list-of-meeting-loan-fund') {
    @if (columnDetails?.field === 'fundName') {
        @if (rowData[columnDetails?.field] !== 'Total') {
            <div
                class="link"
                (click)="onLinkClick(rowData[columnDetails?.field])"
            >
                {{ rowData[columnDetails?.field] }}
            </div>
        }
        @if (rowData[columnDetails?.field] === 'Total') {
            <div>
                {{ rowData[columnDetails?.field] }}
            </div>
        }
    }
}

@if (
    entity === 'loanSchedulerTableEntity' ||
    entity === 'existingSchedulerTableEntity'
) {
    @if (
        columnDetails?.field === 'installmentAmount' ||
        columnDetails?.field === 'totalInstallmentAmount'
    ) {
        <span>
            ₹ {{ (rowData[columnDetails?.field] || 0) | number: '1.2-2' }}
        </span>
        <mat-icon
            class="info-icon"
            matTooltipClass="custom-tooltip"
            [matTooltip]="
                ('principal' | translate) +
                ' = ₹' +
                ((entity === 'loanSchedulerTableEntity'
                    ? rowData['installmentPrincipal']
                    : rowData['principalDemand']
                ) | number: '1.2-2') +
                '\n' +
                ('interest' | translate) +
                ' = ₹' +
                ((entity === 'loanSchedulerTableEntity'
                    ? rowData['installmentInterest']
                    : rowData['interestDemandSchedule']
                ) | number: '1.2-2')
            "
        >
            info
        </mat-icon>
    }
}

@if (entity === 'clf-meetings-clf-cash' || entity === 'clf-meetings-clf-bank') {
    @if (
        columnDetails?.field === 'amountReceived' ||
        columnDetails?.field === 'amountPaid'
    ) {
        <span>{{ rowData[columnDetails?.field] | indianCurrency: true }}</span>
        @if (
            rowData['isGrouped'] &&
            rowData[columnDetails?.field] > 0 &&
            (rowData['principalAmount'] || rowData['interestAmount'])
        ) {
            <mat-icon
                class="info-icon"
                matTooltipClass="custom-tooltip"
                [matTooltip]="
                    ('principal' | translate) +
                    ' = ₹' +
                    (rowData['principalAmount'] | number: '1.2-2') +
                    '\n' +
                    ('interest' | translate) +
                    ' = ₹' +
                    (rowData['interestAmount'] | number: '1.2-2')
                "
            >
                info
            </mat-icon>
        }
    }
}

@if (entity === 'transactionDetailsTableEntity' || entity === 'clf-receipts') {
    @if (columnDetails?.field === 'amount') {
        <span>{{ rowData['amount'] | indianCurrency: true }}</span>
        @if (
            !rowData['isInterestAmountNull'] &&
            (rowData['principalAmount'] || rowData['interestAmount'])
        ) {
            <mat-icon
                class="info-icon"
                matTooltipClass="custom-tooltip"
                [matTooltip]="
                    ('principal' | translate) +
                    ' = ₹' +
                    rowData['principalAmount'] +
                    '\n' +
                    ('interest' | translate) +
                    ' = ₹' +
                    rowData['interestAmount']
                "
            >
                info
            </mat-icon>
        }
    }
}

@if (entity === 'open-transaction') {
    @if (columnDetails?.field === 'receiptMode') {
        @switch (rowData['modePayment']) {
            @case (1) {
                {{ 'cash' | translate }}
            }
            @case (2) {
                {{ 'bank' | translate }}
            }
            @case (3) {
                {{ 'online' | translate }}
            }
        }
    }

    @if (columnDetails?.field === 'amountReceived') {
        <span>{{ rowData['amountReceived'] | indianCurrency }}</span>
        @if (!rowData['isInterestAmountNull']) {
            <mat-icon
                class="info-icon"
                [matTooltip]="
                    ('principal' | translate) +
                    ' = ₹' +
                    rowData['principalAmount'] +
                    ', ' +
                    ('interest' | translate) +
                    ' = ₹' +
                    rowData['interestAmount']
                "
            >
                info
            </mat-icon>
        }
    }
}

@if (
    entity === 'shg-regular-group-new-borrowings' ||
    entity === 'shg-cutoff-group-active-loans-table'
) {
    @if (
        columnDetails?.field === 'institution' ||
        columnDetails?.field === 'institutionName'
    ) {
        <div class="link" (click)="onLinkClick(rowData[columnDetails?.field])">
            {{ rowData[columnDetails?.field] }}
        </div>
    }
}

@if (entity === 'shg-regular-loan-request-details-table') {
    @if (columnDetails?.field === 'requestId') {
        <div class="link" (click)="onLinkClick(rowData[columnDetails?.field])">
            {{ rowData[columnDetails?.field] }}
        </div>
    }
}

@if (entity === 'shg-regular-summary-table') {
    @if (columnDetails?.field === 'description') {
        {{ rowData[columnDetails?.field] | translate }}
    }
}

@if (entity === 'regular-meeting-summary') {
    <div [class.jv-entry]="rowData?.isJV">
        @if (columnDetails?.field === 'particulars') {
            <div matTooltip="{{ rowData[columnDetails?.field] }}">
                {{ rowData[columnDetails?.field]
                }}{{ rowData?.isJV ? ' (JV)' : '' }}
            </div>
        } @else if (
            columnDetails?.field === 'amount' && columnDetails?.isIndianCurrency
        ) {
            {{ rowData[columnDetails?.field] ? '₹' : '' }}
            {{ rowData[columnDetails?.field] | number: '1.2-2' }}
        } @else {
            {{ rowData[columnDetails?.field] }}
        }
    </div>
}

@if (
    entity === 'vo-regular-receipt-shg-to-vo-details' ||
    entity === 'vo-regular-payment-vo-to-clf' ||
    entity === 'vo-regular-payment-vo-to-bank'
) {
    @if (columnDetails?.field === 'paymentMode') {
        @if (rowData['loanNo']) {
            <div
                class="link"
                (click)="onLinkClick(rowData[columnDetails?.field])"
            >
                {{ rowData[columnDetails?.field] }}
            </div>
        } @else {
            {{ rowData[columnDetails?.field] }}
        }
    }
}

@if (entity === 'pfms_pending_component') {
    @if (columnDetails?.field === 'bankStatus') {
        <div
            class="profile-status"
            [ngClass]="{
                pending: rowData[columnDetails?.field] === 'Pending',
                rejected: rowData[columnDetails?.field] === 'Rejected',
                approved: rowData[columnDetails?.field] === 'Approved',
                'under-review':
                    rowData[columnDetails?.field] === 'Under Review',
            }"
        >
            <p>{{ rowData[columnDetails?.field] }}</p>
        </div>
    }
    @if (columnDetails?.field === 'cboName') {
        <div class="link" (click)="onLinkClick(rowData[columnDetails?.field])">
            {{ rowData[columnDetails?.field] }}
        </div>
    }
}

@if (entity === 'regular-meeting-attendance') {
    @if (columnDetails?.field === 'voNameCode') {
        <div class="name-with-code">
            <span>{{ rowData['voName'] }}</span>
            @if (rowData['voCode']) {
                <span class="cbo-code">({{ rowData['voCode'] }})</span>
            }
        </div>
    } @else if (columnDetails?.field === 'shgNameCode') {
        @if (rowData['shgName']) {
            <div class="name-with-code">
                <span>{{ rowData['shgName'] }}</span>
                @if (rowData['shgCode']) {
                    <span class="cbo-code">({{ rowData['shgCode'] }})</span>
                }
            </div>
        } @else {
            -
        }
    } @else if (columnDetails?.field === 'memberNameCode') {
        <div class="name-with-code">
            <span>{{ rowData['memberName'] }}</span>
            @if (rowData['memberCode']) {
                <span class="cbo-code">({{ rowData['memberCode'] }})</span>
            }
        </div>
    }
}

@if (entity === 'grading-table') {
    @if (columnDetails?.type === 'link') {
        <a class="link-button" (click)="onButtonClick()">
            {{ rowData[columnDetails?.field] }}
        </a>
    } @else {
        @if (columnDetails?.type === 'number') {
            @if (rowData.customTotal) {
                <strong>
                    {{ rowData[columnDetails?.field] | numberFormat }}
                </strong>
            } @else {
                {{ rowData[columnDetails?.field] | numberFormat }}
            }
        } @else if (columnDetails?.type === 'percentage') {
            @if (rowData.customTotal) {
                <strong>
                    {{ rowData[columnDetails?.field] | number: '1.2-2' }}
                </strong>
            } @else {
                {{ rowData[columnDetails?.field] | number: '1.2-2' }}
            }
        } @else {
            @if (rowData.customTotal) {
                <strong>
                    {{ rowData[columnDetails?.field] }}
                </strong>
            } @else {
                {{ rowData[columnDetails?.field] }}
            }
        }
        @if (
            (columnDetails?.field === 'recorded' &&
                rowData['recordedTrend'] === 'UP') ||
            (columnDetails?.field === 'gradeAPlusCount' &&
                rowData['gradeAPlusTrend'] === 'UP') ||
            (columnDetails?.field === 'gradeACount' &&
                rowData['gradeATrend'] === 'UP') ||
            (columnDetails?.field === 'gradeBPlusCount' &&
                rowData['gradeBPlusTrend'] === 'UP') ||
            (columnDetails?.field === 'gradeBCount' &&
                rowData['gradeBTrend'] === 'UP') ||
            (columnDetails?.field === 'gradeCCount' &&
                rowData['gradeCTrend'] === 'UP') ||
            (columnDetails?.field === 'gradeDCount' &&
                rowData['gradeDTrend'] === 'UP') ||
            (columnDetails?.field === 'notGradedCount' &&
                rowData['notGradedTrend'] === 'UP')
        ) {
            <img src="/assets/images/green-up.svg" alt="icon" />
        }
        @if (
            (columnDetails?.field === 'recorded' &&
                rowData['recordedTrend'] === 'DOWN') ||
            (columnDetails?.field === 'gradeAPlusCount' &&
                rowData['gradeAPlusTrend'] === 'DOWN') ||
            (columnDetails?.field === 'gradeACount' &&
                rowData['gradeATrend'] === 'DOWN') ||
            (columnDetails?.field === 'gradeBPlusCount' &&
                rowData['gradeBPlusTrend'] === 'DOWN') ||
            (columnDetails?.field === 'gradeBCount' &&
                rowData['gradeBTrend'] === 'DOWN') ||
            (columnDetails?.field === 'gradeCCount' &&
                rowData['gradeCTrend'] === 'DOWN') ||
            (columnDetails?.field === 'gradeDCount' &&
                rowData['gradeDTrend'] === 'DOWN') ||
            (columnDetails?.field === 'notGradedCount' &&
                rowData['notGradedTrend'] === 'DOWN')
        ) {
            <img src="/assets/images/red-down.svg" alt="icon" />
        }
    }
}

@if (entity === 'progress-review-table') {
    @if (columnDetails?.type === 'link') {
        <a class="link-button" (click)="onButtonClick()">
            {{ rowData[columnDetails?.field] }}
        </a>
    } @else if (
        columnDetails?.field === 'cutoffRank' ||
        columnDetails?.field === 'regularRank'
    ) {
        {{
            rowData[columnDetails?.field]
                ? (+rowData[columnDetails?.field] | ordinal)
                : rowData[columnDetails?.field]
        }}
    } @else {
        @if (columnDetails?.type === 'number') {
            @if (rowData.customTotal) {
                <strong>
                    {{ rowData[columnDetails?.field] | numberFormat }}
                </strong>
            } @else {
                {{ rowData[columnDetails?.field] | numberFormat }}
            }
        } @else if (columnDetails?.type === 'percentage') {
            @if (rowData.customTotal) {
                <strong>
                    {{ rowData[columnDetails?.field] | number: '1.2-2' }}
                </strong>
            } @else {
                {{ rowData[columnDetails?.field] | number: '1.2-2' }}
            }
        } @else {
            @if (rowData.customTotal) {
                <strong>
                    {{ rowData[columnDetails?.field] }}
                </strong>
            } @else {
                {{ rowData[columnDetails?.field] }}
            }
        }
        @if (
            (columnDetails?.field === 'regularRecorded' &&
                rowData['regularRecordedTrend'] === 'UP') ||
            (columnDetails?.field === 'regularRecordedPercentage' &&
                rowData['regularRecordedPercentageTrend'] === 'UP') ||
            (columnDetails?.field === 'regularPending' &&
                rowData['regularPendingTrend'] === 'UP') ||
            (columnDetails?.field === 'regularPendingPercentage' &&
                rowData['regularPendingPercentageTrend'] === 'UP') ||
            (columnDetails?.field === 'cutoffRecorded' &&
                rowData['cutoffRecordedTrend'] === 'UP') ||
            (columnDetails?.field === 'cutoffRecordedPercentage' &&
                rowData['cutoffRecordedPercentageTrend'] === 'UP' &&
                columnDetails?.field === 'cutoffPending' &&
                rowData['cutoffRecordedTrend'] === 'UP') ||
            (columnDetails?.field === 'cutoffPendingPercentage' &&
                rowData['cutoffRecordedPercentageTrend'] === 'UP')
        ) {
            <img src="/assets/images/green-up.svg" alt="icon" />
        }
        @if (
            (columnDetails?.field === 'regularRecorded' &&
                rowData['regularRecordedTrend'] === 'DOWN') ||
            (columnDetails?.field === 'regularRecordedPercentage' &&
                rowData['regularRecordedPercentageTrend'] === 'DOWN') ||
            (columnDetails?.field === 'regularPending' &&
                rowData['regularPendingTrend'] === 'DOWN') ||
            (columnDetails?.field === 'regularPendingPercentage' &&
                rowData['regularPendingPercentageTrend'] === 'DOWN') ||
            (columnDetails?.field === 'cutoffRecorded' &&
                rowData['cutoffRecordedTrend'] === 'DOWN') ||
            (columnDetails?.field === 'cutoffRecordedPercentage' &&
                rowData['cutoffRecordedPercentageTrend'] === 'DOWN' &&
                columnDetails?.field === 'cutoffPending' &&
                rowData['cutoffRecordedTrend'] === 'DOWN') ||
            (columnDetails?.field === 'cutoffPendingPercentage' &&
                rowData['cutoffRecordedPercentageTrend'] === 'DOWN')
        ) {
            <img src="/assets/images/red-down.svg" alt="icon" />
        }
    }
}
